import { API_BASE } from "../config/constants";


export const isMultiplePricingEnabled = (profile) =>
  [true, 1, "1", "true", "yes"].includes(
    typeof profile?.multiple_price_lists_enabled === "string"
      ? profile.multiple_price_lists_enabled.toLowerCase()
      : profile?.multiple_price_lists_enabled
  );

export const priceListRequest = async (path, payload) => {
  const response = await fetch(`${API_BASE}/price-lists/${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  const json = await response.json().catch(() => ({}));
  if (!response.ok || json?.success === false) {
    const validationMessage = json?.errors
      ? Object.values(json.errors).flat().find(Boolean)
      : null;
    throw new Error(validationMessage || json?.message || "Price list request failed");
  }
  return json;
};

export const scalePriceFields = (entity, alternatePrice) => {
  const target = Number(alternatePrice);
  if (!Number.isFinite(target) || target < 0) return entity;
  const regularDisplay = Number(
    entity?.taxedprice ?? entity?.priceaftertax ?? entity?.price ?? 0
  );
  if (!(regularDisplay > 0)) {
    return { ...entity, price: target, priceaftertax: target, taxedprice: target, taxamount: 0 };
  }
  const ratio = target / regularDisplay;
  const scaled = (value, fallback = 0) =>
    Number((Number(value ?? fallback) * ratio).toFixed(2));
  return {
    ...entity,
    price: scaled(entity?.price, regularDisplay),
    priceaftertax: scaled(entity?.priceaftertax, regularDisplay),
    taxedprice: target,
    taxamount: scaled(entity?.taxamount, 0),
    sgst: scaled(entity?.sgst, 0),
    cgst: scaled(entity?.cgst, 0),
  };
};

export const restoreSavedLineTax = (savedLine = {}, referenceLine = {}) => {
  const savedPrice = Number(savedLine?.price ?? savedLine?.priceaftertax ?? 0);
  const savedBase = Number(savedLine?.priceaftertax ?? savedLine?.price ?? 0);
  const referenceBase = Number(referenceLine?.priceaftertax ?? referenceLine?.price ?? 0);
  const referenceTax = Number(referenceLine?.taxamount ?? 0);
  const explicitTaxedPrice = Number(savedLine?.taxedprice);
  const hasExplicitTaxedPrice =
    savedLine?.taxedprice !== null &&
    savedLine?.taxedprice !== undefined &&
    savedLine?.taxedprice !== "" &&
    Number.isFinite(explicitTaxedPrice);
  const scale = referenceBase > 0 ? savedBase / referenceBase : 0;
  const taxamount = Number(
    (hasExplicitTaxedPrice
      ? Math.max(0, explicitTaxedPrice - savedBase)
      : referenceTax * scale
    ).toFixed(2)
  );
  return {
    ...referenceLine,
    ...savedLine,
    price: savedPrice,
    priceaftertax: savedBase,
    taxedprice: hasExplicitTaxedPrice
      ? explicitTaxedPrice
      : Number((savedBase + taxamount).toFixed(2)),
    taxamount,
    sgst: Number((Number(referenceLine?.sgst ?? 0) * scale).toFixed(2)),
    cgst: Number((Number(referenceLine?.cgst ?? 0) * scale).toFixed(2)),
  };
};
